import type { CashflowPredictionGroup, ICashflowPrediction, ICreditLinePortfolio } from '@condo/domain';
import { getClient } from './api-client';

export interface IUpdateCreditLinePortfolioParams {
    name: string;
    seniorPartnerId: number;
    juniorPartnerId: number;
    seniorAmount: number;
    juniorAmount: number;
    startDate: Date;
    endDate: Date;
}

export interface IGetCreditLinePortfolioOpts {
    withPartners?: boolean;
    withEstates?: boolean;
    withEstateLocations?: boolean;
}

export const fetchCreditLinePortfolios = async (opts?: IGetCreditLinePortfolioOpts): Promise<ICreditLinePortfolio[]> =>
    getClient('basecamp')
        .get('/credit-line-portfolios', { params: opts })
        .then(({ data }) => data.creditLinePortfolios);

export const fetchCreditLinePortfolio = async (creditLinePortfolioId: number): Promise<ICreditLinePortfolio> =>
    getClient('basecamp')
        .get(`/credit-line-portfolios/${creditLinePortfolioId}`)
        .then(({ data }) => data.creditLinePortfolio);

export const updateCreditLinePortfolio = async (creditLinePortfolioId: number, params: IUpdateCreditLinePortfolioParams): Promise<ICreditLinePortfolio> =>
    getClient('basecamp')
        .put(`/credit-line-portfolios/${creditLinePortfolioId}`, params)
        .then(({ data }) => data.creditLinePortfolio);

export const addEstatesToCreditLinePortfolio = async (creditLinePortfolioId: number, estateIds: number[]): Promise<ICreditLinePortfolio> =>
    getClient('basecamp')
        .post(`/credit-line-portfolios/${creditLinePortfolioId}/estates`, { estateIds })
        .then(({ data }) => data.creditLinePortfolio);

export const deleteEstatesFromCreditLinePortfolio = async (creditLinePortfolioId: number, estateIds: number[]): Promise<ICreditLinePortfolio> =>
    getClient('basecamp').delete(`/credit-line-portfolios/${creditLinePortfolioId}/estates`, {
        params: {
            estateIds,
        },
    });

export const fetchCreditLineCashflowPrediction = async (creditLinePortfolioId: number, group: CashflowPredictionGroup): Promise<ICashflowPrediction> =>
    getClient('basecamp')
        .get(`/credit-line-portfolios/${creditLinePortfolioId}/cashflow-predictions`, { params: { group } })
        .then(({ data }) => data.cashflowPrediction);

export const generateCreditLineCashflowPredictions = async (cashflowPredictionId: number): Promise<{ sheetLink: string; sheetDate: Date }> =>
    getClient('basecamp')
        .post(`/credit-line-portfolios/cashflow-predictions/${cashflowPredictionId}/sheet`)
        .then(({ data }) => data);

export const generateCreditLineBudgetCostsSheet = async (cashflowPredictionId: number): Promise<{ sheetLink: string; sheetDate: Date }> =>
    getClient('basecamp')
        .post(`/credit-line-portfolios/cashflow-predictions/${cashflowPredictionId}/budget-costs/sheet`)
        .then(({ data }) => data);
